import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import {pageList, toggleEnableStatus} from "@/api/msgOssTemplate";
import {onMounted, reactive} from "vue";
import {message} from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = [
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        customRender: ({ index }: any) => `${index + 1}`,
    },
    {
        title: "编号",
        dataIndex: "code",
        key: "code",
    },
    {
        title: "名称",
        dataIndex: "name",
        key: "name",
    },
    {
        title: "内容",
        dataIndex: "content",
        key: "content",
        width:350
    },
    {
        title: "启用状态",
        dataIndex: "isEnable",
        key: "isEnable",
    },
    {
        title: "操作",
        dataIndex: "operation",
        key: "operation",
    },
];



const data = reactive({
    loading: false,
    switchLoading: false,
    keyword: "",
    dataOptions: [],
    pagination: {
        size: "small",
        current: 1,
        pageSize: 5,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total: string) => {
            return " 共" + total + "条";
        },
        hideOnSinglePage: false,
        showSizeChanger: true,
    },
})

const toggleStatus = (id: string)=>{
    data.switchLoading = true
    toggleEnableStatus(id).then(()=>{
        message.success("切换成功！")
        search();
        data.switchLoading = false
    }).catch(()=>{
        data.switchLoading = false
    })
}

 const search = ()=>{
    let option = {
        keyword: data.keyword,
        page: {
            pageSize: data.pagination.pageSize,
            currPage: data.pagination.current,
        }
    }
     data.loading = true
     pageList(option).then((res: any)=>{
         data.dataOptions = res && res.data?res.data:[];
         data.pagination.total = res.records;
         data.loading = false
     })
 }

const changePageIndex = (page: any) => {
    data.pagination.pageSize = page.pageSize;
    data.pagination.current = page.current;
    search();
};

onMounted(()=>{
    search()
})


return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_table, {
      dataSource: data.dataOptions,
      columns: columns,
      loading: data.loading,
      pagination: data.pagination,
      onChange: changePageIndex
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'isEnable')
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: record.isEnable?'success':'default'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.isEnable?'已启用':'已禁用'), 1)
              ]),
              _: 2
            }, 1032, ["color"]))
          : _createCommentVNode("", true),
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createBlock(_component_a_popconfirm, {
              key: 1,
              title: '确认'+(record.isEnable?'禁用':'启用')+'该模板吗？',
              "ok-text": "确定",
              "cancel-text": "取消",
              onConfirm: ($event: any) => (toggleStatus(record.id)),
              onCancel: search
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: record.isEnable?'danger':'primary'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(record.isEnable?'禁用':'启用'), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 2
            }, 1032, ["title", "onConfirm"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading", "pagination"])
  ]))
}
}

})